import React, { useEffect, useState } from 'react';
import { Table } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { SteamingMetricColumn } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/SteamingCloums';
import { sortStreamingTableByMetric, getPlatform } from '../../_util';
import { valueFormat, growthFormat } from '@/pages/intelligence/utils/commonUtils';
import { DateColumns } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/DateCloums';
import { useIntl } from 'umi';
import { buildMetricCompareData } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/metricCompare';
const { pageable, scrollable } = Table.addons;

const TrendsCard = (props: any) => {
  const {
    tableData = [],
    entityType,
    gameName,
    gameCover,
    dateType,
    startDate,
    endDate,
    tableHeaderOptions,
    onTableSortChage,
    pageSortAttr: defaultPageSortAttr,
  } = props;

  const { formatMessage } = useIntl();
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortAttr, setPageSortAttr] = useState(defaultPageSortAttr);

  useEffect(() => {
    onSortChage({
      sortMetric: defaultPageSortAttr?.currentSortMetric,
      sortVal: defaultPageSortAttr?.currentSortValue,
      ratioType: defaultPageSortAttr?.currentRatioType,
    });
    setPageSortAttr(defaultPageSortAttr);
  }, [tableData, defaultPageSortAttr]);

  const handleSortChange = (e: SortByItemType) => {
    onTableSortChage?.(e);
    onSortChage(e);
  };

  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e.ratioType,
    });
    const sortTable = sortStreamingTableByMetric(tableData, e);
    setSortTableData(sortTable);
  };

  const getMetricValueOfCvm = (cvm: any, metricKey: string) => {
    const metric = getPlatform(cvm?.platform, metricKey);
    const value = valueFormat(metric?.value);
    const growthDataObj = growthFormat({
      value: metric?.growth_ratio,
      valueType: 'percentValue',
      hasPoint: 'lessThanOne',
      fixedNum: 2,
      maxNumber: 99999,
      zeroValue: '0% -',
    });
    const dataCompareData = buildMetricCompareData({
      metric,
      granularity: dateType,
      startDate,
      endDate,
      title: gameName,
      icon: gameCover,
      entityType: entityType || 'mobile',
      valueFormatter: (rawValue) => {
        const numValue = Number(rawValue);

        if (!Number.isFinite(numValue)) {
          return '-';
        }

        return valueFormat(numValue);
      },
    });

    return {
      value,
      growthDataObj,
      dataCompareData,
    };
  };

  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    // DAU Revenue Download 每个数据源赋值一遍
    tableHeaderOptions?.forEach((t) => {
      metricCloums.push(
        SteamingMetricColumn({
          width: t?.width,
          width_cn: t?.width_cn || t?.width,
          dataSource: t?.dataSource,
          svgIcon: t?.svgIcon,
          title: t?.text,
          textContent: t?.textContent,
          key: `${t?.value}`,
          sortMetric: t?.value,
          currentSortValue: pageSortAttr?.currentSortValue,
          currentSortKey: `${pageSortAttr?.currentSortMetric}_${pageSortAttr?.currentRatioType}`,
          onSortChage: handleSortChange,
          metricKey: t?.metricKey || t?.value,
          getMetricValueOfCvm,
          entityType,
        }),
      );
    });
    return metricCloums;
  };

  return (
    <>
      <Table
        //   verticalTop
        bordered="all"
        records={sortTableData}
        className="dbi-mobileGames-details-table"
        columns={[
          DateColumns({
            key: 'date',
            sortMetric: 'date',
            title: formatMessage({ id: `dbi_date` }),
            currentSortMetric: pageSortAttr?.currentSortMetric,
            currentSortValue: pageSortAttr?.currentSortValue,
            dateType,
            onSortChage: handleSortChange,
            width: 'auto',
          }),
          ...getMetricCloums(),
        ]}
        addons={[
          pageable({
            stateTextVisible: true,
            pageSizeVisible: sortTableData?.length > 5,
            pageIndexVisible: sortTableData?.length > 5,
            jumpVisible: sortTableData?.length > 5,
            endJumpVisible: sortTableData?.length > 5,
            // pageSizeOptions: [5, 10, 15],
          }),
          scrollable({
            //   maxHeight: 580,
            // minWidth: 2500
            //     tHeaderList?.length > 3
            //       ? 220 * tHeaderList?.length + 300
            //       : 'auto',
          }),
        ]}
      />
    </>
  );
};

export default TrendsCard;
